import React, { useState } from 'react';
import { OrderDetailTitle } from 'src/pages/orders/components/orderDetails/OrderDetails.styled';
import SetsOrderDetail from 'src/pages/orders/components/orderDetails/orderDetailTab/setsOrderDetail/SetsOrderDetail';
import { useTranslation } from 'react-i18next';

const OrderDetail = ({ handleSetItemClick, ordersList }) => {
    const { t } = useTranslation();
    const [expandedCard, setExpandedCard] = useState({
        sets: true,
    });

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    const { sets } = expandedCard;

    return (
        <>
            <OrderDetailTitle>{t('orders.orderSummaryTabs.setAvailabilityPending')}</OrderDetailTitle>
            <SetsOrderDetail
                toggleCard={toggleCard}
                sets={sets}
                isSetAvailabilityPending
                handleSetItemClick={handleSetItemClick}
                ordersList={ordersList}
            />
        </>
    );
};

export default OrderDetail;
